// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"102":"378871cc","561":"378871cc"}[chunkId] + ".chunk.css";
};